<script setup lang="ts">
import { ref } from "vue";
import DRBtn from "@/components/UI/DRBtn.vue";

defineProps<{
  title: string;
}>();
defineEmits<{
  (e: "confirm"): void;
}>();
const show = ref(false);
</script>

<template>
  <el-popconfirm
    :title="title"
    @confirm="$emit('confirm')"
    @cancel="show = false"
  >
    <template #reference>
      <slot></slot>
    </template>
    <template #actions="{ confirm, cancel }">
      <DRBtn
        variant="outline"
        size="xs"
        :label="$t('no')"
        @click="cancel"
        class="mx-2"
      />
      <DRBtn variant="danger" size="xs" :label="$t('yes')" @click="confirm" />
    </template>
  </el-popconfirm>
</template>

<style lang="scss" scoped></style>
